import { PROCESSORS, TRUST_CHECKED, TRUST_FACTS } from "../pages/trust-facts"
import { englishDateToZh, STORAGE_SENTENCE_ZH } from "./dates"

/**
 * Chinese rendering of the /trust fact tables (D-WEB-LANG-SCOPE). The English `TRUST_FACTS` and
 * `PROCESSORS` stay the single source: each Chinese row below is matched to its English row by
 * position, and `zh-pages.test.tsx` fails when the row count, the numbers or the source links differ.
 * Never add or change a fact here first; change trust-facts.ts, then translate it.
 */
export interface TrustFactZh {
  label: string
  value: string
  /** Chinese name of the source; the link (if any) comes from the English row. */
  sourceLabel: string
}

const US = "公司总部在美国。"

export const TRUST_CHECKED_ZH = englishDateToZh(TRUST_CHECKED)

const CONFIG = "我们的托管与服务配置"

export const TRUST_FACTS_ZH: readonly TrustFactZh[] = [
  {
    label: "谁提供 Kestly",
    value: "Cave Sight（ABN 48 587 662 266），一家个体经营企业。联系邮箱：hello@kestly.com.au。",
    sourceLabel: CONFIG,
  },
  {
    label: "数据存放在哪里",
    value: STORAGE_SENTENCE_ZH,
    sourceLabel: CONFIG,
  },
  {
    label: "还有谁处理数据",
    value: "少数位于澳大利亚境外的服务会为我们处理部分数据，它们列在下面的第二张表里。",
    sourceLabel: CONFIG,
  },
  {
    label: "记录保存多久",
    value:
      "ATO 要求大多数经营记录保存 5 年。我们不承诺替你保存那么久。付费套餐失效后，我们最多再保留你的数据 3 个月，期间仍可查看和导出，并在数据从账户中移除前的 60、30、14、7 和 1 天提醒你导出。",
    sourceLabel: "ATO，保存经营记录概览",
  },
  {
    label: "导出",
    value: "行程、收据和发票随时可以导出成 CSV 或 PDF。",
    sourceLabel: "Kestly 导出功能",
  },
  {
    label: "删除账户",
    value: "在应用的“设置”里，或在网页上删除账户。账户会先进入 30 天的待删除期，之后删除。",
    sourceLabel: "删除账户（英文）",
  },
]

export const PROCESSORS_ZH: readonly TrustFactZh[] = [
  {
    label: "Supabase",
    value: `托管我们的数据库和登录服务。${US}`,
    sourceLabel: CONFIG,
  },
  {
    label: "Resend",
    value: `发送登录验证码等邮件，以及你通过联系表单发给我们的消息。${US}`,
    sourceLabel: CONFIG,
  },
  {
    label: "Anthropic",
    value: `读取收据图片和助手消息，仅在你使用 AI 读取收据或助手时进行。${US}处理发生在澳大利亚境外。`,
    sourceLabel: CONFIG,
  },
  {
    label: "Google 和 Apple 登录",
    value:
      "计划在上线时提供，目前尚未开放。你选择用 Google 或 Apple 登录时，该公司向我们确认你的身份并分享你的邮箱地址（Apple 可以用私密中继地址把它藏起来）。两家公司的总部都在美国。",
    sourceLabel: CONFIG,
  },
  {
    label: "Stripe",
    value: `网页结账上线后（目前尚未上线）用来处理网页付款。${US}`,
    sourceLabel: CONFIG,
  },
  {
    label: "Apple 和 Google（在你的手机上）",
    value:
      "使用你手机操作系统自带的地图和地址服务，显示地图，并把行程的起点和终点转成区（suburb）的名称。两家公司的总部都在美国。",
    sourceLabel: CONFIG,
  },
  {
    label: "Cloudflare",
    value: `提供网站服务并运行我们的应用代码。${US}`,
    sourceLabel: CONFIG,
  },
]

/** The English rows and their Chinese partners, paired by position (the test keeps the two lists in step). */
export const pairedFacts = (
  zh: readonly TrustFactZh[],
  en: readonly (typeof TRUST_FACTS)[number][],
) => zh.map((row, i) => ({ ...row, href: en[i]?.source.href }))

export const TRUST_ROWS_ZH = pairedFacts(TRUST_FACTS_ZH, TRUST_FACTS)
export const PROCESSOR_ROWS_ZH = pairedFacts(PROCESSORS_ZH, PROCESSORS)
